export default "__VITE_ASSET__3fe5eee7__"